import { useQuery } from "@tanstack/react-query";
import { http } from "../../utils";

export async function fetchProductLotsQnt(id) {
  const { data } = await http(`/admin/product-lots-qnt?productId=${id}`);

  return data;
}

export function useProductLotsQnt(id) {
  const { data, ...raResult } = useQuery(["product-lots-qnt"], () =>
    fetchProductLotsQnt(id)
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}
